<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2022-05-28 22:04:37
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 09:57:47
-->
<template>
  <div>
    <!-- searchImport -->
    <search-area
      tabName="服务人员列表"
      searchAdd
      searchExport
      searchImport
      @search="search(1)"
      @add="clickAdd"
      @goexport="goexportExpert"
      @import="importClear"
    >
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="服务人员名称" prop="name" :label-width="105">
          <Input
            v-model="searchParam.name"
            placeholder="请输入服务人员手机号"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
        <FormItem label="当前状态" prop="nowStatus" :label-width="105">
          <Select
            v-model="searchParam.nowStatus"
            placeholder="请选择当前状态"
            style="width: 200px"
            clearable
          >
            <Option value="1">服务中</Option>
            <Option value="2">空闲中</Option>
            <Option value="3">未上线</Option>
          </Select>
        </FormItem>
        <FormItem
          label="公司名称"
          prop="name"
          :label-width="105"
          v-if="!companyId"
        >
          <Select
            v-model="searchParam.companyId"
            style="width: 160px"
            clearable
            @on-change="search(1)"
          >
            <Option
              v-for="item in companyList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="cleanList"
      :total="total"
      @search="search"
      :pageNum="searchParam.currentPage"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog
      title="新增服务人员"
      top="50px"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="showNewDialog"
      @close="closeNewDialog"
    >
      <el-form
        ref="formData"
        :rules="rule"
        :model="formData"
        :hide-required-asterisk="false"
      >
        <el-form-item label="姓名" label-width="120px" prop="realName">
          <el-input
            size="mini"
            placeholder="请输入姓名"
            style="width: 200px"
            v-model="formData.realName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" label-width="120px" prop="phone">
          <el-input
            size="mini"
            placeholder="请输入手机号"
            style="width: 200px"
            v-model="formData.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号" label-width="120px" prop="idNumber">
          <el-input
            size="mini"
            placeholder="请输入身份证号"
            style="width: 200px"
            v-model="formData.idNumber"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="职业证书"
          label-width="120px"
          prop="certificateUrl"
        >
          <el-upload
            class="form-upload"
            action="#"
            name="certificateUrl"
            accept=".png, .jpg, .jpeg"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onUploadCertificate"
          >
            <el-button slot="trigger" size="mini" type="primary"
              >上传职业证书</el-button
            >
          </el-upload>
          <span
            v-if="formData.certificateUrl"
            style="
              display: inline-block;
              width: 100px;
              height: 100px;
              position: relative;
            "
          >
            <img
              @click="deleteCertificate"
              src="@/assets/delete.png"
              style="height: 20px; width: 20px; position: absolute; right: 0"
            />
            <el-popover placement="left" title="" trigger="hover" width="200">
              <img :src="formData.certificateUrl" width="100%" />
              <img
                slot="reference"
                :src="formData.certificateUrl"
                :alt="formData.certificateUrl"
                style="height: 80px; width: 80px; padding: 10px"
              />
            </el-popover>
          </span>
        </el-form-item>
        <el-form-item
          label="身份证正反面"
          label-width="120px"
          prop="idNumberUrl"
        >
          <el-upload
            class="form-upload"
            action="#"
            name="idNumberUrl"
            accept=".png, .jpg, .jpeg"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onUploadIdNumber"
          >
            <el-button slot="trigger" size="mini" type="primary"
              >上传身份证</el-button
            >
          </el-upload>
          <span
            v-if="formData.idNumberUrl"
            style="
              display: inline-block;
              width: 100px;
              height: 100px;
              position: relative;
            "
          >
            <img
              @click="deleteIdNumber"
              src="@/assets/delete.png"
              style="height: 20px; width: 20px; position: absolute; right: 0"
            />
            <el-popover placement="left" title="" trigger="hover" width="200">
              <img :src="formData.idNumberUrl" width="100%" />
              <img
                slot="reference"
                :src="formData.idNumberUrl"
                :alt="formData.idNumberUrl"
                style="height: 80px; width: 80px; padding: 10px"
              />
            </el-popover>
          </span>
        </el-form-item>
        <el-form-item label="所属公司" label-width="120px" prop="companyId">
          <el-select
            :disabled="companyId > 0"
            v-model="formData.companyId"
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in companyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="d-flex flex-center">
        <el-button size="small" @click="showNewDialog = false">取消 </el-button>
        <el-button type="primary" size="small" @click="onSubmit"
          >确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="导入服务人员"
      top="100px"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="importClearDialog"
      @close="closeClearDialog"
    >
      <div>
        <el-upload
          ref="upload"
          accept=".xlsx,.xls"
          drag
          :auto-upload="false"
          :http-request="uploadClearList"
          action="#"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件</div>
        </el-upload>
      </div>
      <div slot="footer">
        <el-button size="small" @click="showNewDialog = false">取消 </el-button>
        <el-button type="primary" size="small" @click="onSubmitFile"
          >确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="审核服务人员"
      top="50px"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="showReviewDialog"
      @close="closeReviewDialog"
    >
      <el-form
        ref="reviewFormData"
        :rules="reviewRule"
        :model="reviewFormData"
        :hide-required-asterisk="false"
      >
        <el-form-item label="审核状态" label-width="120px" prop="reviewStatus">
          <el-select
            v-model="reviewFormData.reviewStatus"
            placeholder="请选择审核状态"
            size="mini"
            style="width: 200px"
          >
            <el-option label="通过" value="2"></el-option>
            <el-option label="不通过" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="d-flex flex-center">
        <el-button size="small" @click="closeReviewDialog">取消 </el-button>
        <el-button type="primary" size="small" @click="onSubmitReview"
          >确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./cleaner-column";
export default {
  data() {
    let validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号不能为空！"));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确！"));
      } else {
        callback();
      }
    };
    return {
      columns: columns(this),
      companyId: window.userInfo.companyId || "",
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        name: "",
        nowStatus: "",
        currentPage: 1,
        pageSize: 10,
        companyId: window.userInfo.companyId || "", //公司ID
      },
      cleanList: [],
      companyList: [],
      formData: {
        realName: "",
        phone: "",
        companyId: window.userInfo.companyId || "",
        idNumber: "",
        certificateUrl: "",
        idNumberUrl: "",
      },
      showNewDialog: false,
      importClearDialog: false,
      showReviewDialog: false,
      reviewFormData: {
        userId: "",
        reviewStatus: "",
        type: "",
        id: "",
      },
      reviewRule: {
        reviewStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
      },
      rule: {
        realName: [
          { required: true, message: "请输入服务人员姓名", trigger: "change" },
        ],
        phone: [{ required: true, validator: validatePhone }],
        companyId: [
          { required: true, message: "请选择公司", trigger: "change" },
        ],
        idNumber: [
          { required: true, message: "请选择身份证号", trigger: "change" },
        ],
      },
    };
  },
  computed: {},
  created() {
    this.getCleanerList();
    this.getCompanyList();
  },
  methods: {
    // 执行搜索
    search(val) {
      this.searchParam.pageNum = val;
      this.getCleanerList();
    },
    // 获取订单列表
    async getCleanerList() {
      let { list, total } = await this.$post(
        "/company/cleanerListByPage",
        this.searchParam,
      );
      this.cleanList = list || [];
      this.total = total || 0;
    },
    // 查询公司列表
    async getCompanyList() {
      let data = await this.$get("/company/all");
      this.companyList = data;
    },
    closeNewDialog() {
      this.showNewDialog = false;
    },
    clickAdd() {
      this.formData = {
        realName: "",
        phone: "",
        companyId: window.userInfo.companyId || "",
        idNumber: "",
        certificateUrl: "",
        idNumberUrl: "",
      };
      this.showNewDialog = true;
    },
    onSubmit() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          await this.$post("/user/addOrEdit", { ...this.formData, type: 2 });
          this.$message.success("添加成功");
          this.showNewDialog = false;
          this.searchParam.pageNum = 1;
          this.getCleanerList();
        }
      });
    },
    // 导出
    goexportExpert() {
      this.$blobpost("/excel/getCleanerTemplate").then((da) => {
        let blob = new Blob([da.data], {
          type: "application/octet-stream",
        }); // 转化为blob对象
        let filename = "导入模版.xls"; // 判断是否使用默认文件名
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          var blobURL = window.URL.createObjectURL(blob); // 将blob对象转为一个URL
          var tempLink = document.createElement("a"); // 创建一个a标签
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", filename); // 给a标签添加下载属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          document.body.appendChild(tempLink); // 将a标签添加到body当中
          tempLink.click(); // 启动下载
          document.body.removeChild(tempLink); // 下载完毕删除a标签
          window.URL.revokeObjectURL(blobURL);
        }
      });
    },
    // 导入营业员
    importClear() {
      this.importClearDialog = true;
    },
    closeClearDialog() {
      this.importClearDialog = false;
    },
    // file文件处理
    uploadClearList(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      this.$upload("/excel/importCleaner", formData).then((da) => {
        this.closeClearDialog();
        this.$message.success("导入成功");
        this.getCleanerList();
      });
    },
    onSubmitFile() {
      this.$refs.upload.submit();
    },
    // 上传职业证书
    async onUploadCertificate(file) {
      const param = new FormData();
      param.append("file", file.raw);
      const url = await this.$upload("/File/upload", param);
      this.formData.certificateUrl = url;
      this.$forceUpdate();
    },
    deleteCertificate() {
      this.$confirm("确认删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.formData.certificateUrl = "";
          this.$forceUpdate();
          this.$message({ type: "success", message: "删除成功!" });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    // 上传身份证正反面
    async onUploadIdNumber(file) {
      const param = new FormData();
      param.append("file", file.raw);
      const url = await this.$upload("/File/upload", param);
      this.formData.idNumberUrl = url;
      this.$forceUpdate();
    },
    deleteIdNumber() {
      this.$confirm("确认删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.formData.idNumberUrl = "";
          this.$forceUpdate();
          this.$message({ type: "success", message: "删除成功!" });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    closeReviewDialog() {
      this.showReviewDialog = false;
      this.reviewFormData = {
        userId: "",
        id: "",
        type: "",
        reviewStatus: "",
      };
      if (this.$refs.reviewFormData) {
        this.$refs.reviewFormData.resetFields();
      }
    },
    onSubmitReview() {
      this.$refs.reviewFormData.validate(async (valid) => {
        if (valid) {
          await this.$post("/user/addOrEdit", {
            userId: this.reviewFormData.userId,
            type: this.reviewFormData.type,
            id: this.reviewFormData.id,
            reviewStatus: this.reviewFormData.reviewStatus,
          });
          this.$message.success("审核成功");
          this.closeReviewDialog();
          this.getCleanerList();
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'

.tableOut
    height: 50px;
    border: 0.1px solid #e0dede;
    background: #f1f4f512;
    span
      width: 20%;
      text-align: center;
      display: inline-block;
      float: left;
      font-size: 17px;
      border-right: 1px solid #e0dede;
      height: 50px;
      line-height: 50px;
      box-sizing: border-box;

.huiline
    padding:10px;
    border: 1px solid #e0dede;
    box-sizing: border-box;
    width: 100%;
    border-top: 0;
    background: #f1f4f512;
    font-size: 13px;
    color: #b3b0b0;

    span
     margin-left 40px
.payitem
    display: flex;
    flex-direction: column;
    text-align: left;
    box-sizing: border-box;
    padding-left: 50px;

.details
    display: flex;
    justify-content: space-around;
    font-size: 13px;
    border-bottom: 1px solid #e0dede;
    border-right: 1px solid #e0dede;

  .divspp
    width:20%;
    border-left: 1px solid #e0dede;
    padding: 10px 0;
    box-sizing:border-box;
    display: flex;
    flex-direction: column;
    align-items:center;
    text-align: left;
    box-sizing: border-box;
    justify-content: center;
.picker
    margin-left 10px

.filter-search
  display flex
  flex-wrap wrap

  .el-date-editor
    max-width 360px
    margin-right 10px
    margin-bottom 10px

  .el-input
    max-width 140px
    margin-right 10px
    margin-bottom 10px

.option-button
  position relative
  padding-right 50px

  .edit-btn
    position absolute
    right 4px

.form-upload-excel
  display inline-block
  margin-left 10px

.table-container
  margin-top 20px

  .el-pagination
    margin-top 20px

  .preview
    display flex
    justify-content center
    align-items center
    padding 10px
    margin-top 6px
    border 1px dashed #999
    border-radius 6px
  .el-dialog
    width: 500px;
.Dealing{
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.wildFinished{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  .DealFinished{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: normal;
    width: 200px;
  }
  .DealFinishedfoot{
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }
}
.direct-mail{
  color: #7600FF;
  border: 1px solid #7600FF;
  padding: 2px;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 12px;
}
</style>
